<template>
  <content-wrapper without-horizontal-spacing no-top-padding no-bottom-padding>
    <div>
      <unified-offers-table />
    </div>
    <portal :to="PortalTarget.SIDEBAR">
      <div class="w-full flex flex-col justify-center items-center pt-6">
        <offer-menu />
      </div>
    </portal>
  </content-wrapper>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import offerStatus from '@/views/Brand/Applications/mixins/offerStatus';
import {
  DEFAULT_QUERY_FORMATTERS,
  DEFAULT_VALUE_GETTERS,
} from '@/constants/filters';
import { PortalTarget } from '@/constants/portal';
import ContentWrapper from '@/layouts/BrandLayout/Components/ContentWrapper';
import UnifiedOffersTable from '@/views/Brand/Applications/Offer/_components/UnifiedOffersTable.vue';
import OfferMenu from '@/views/Brand/Applications/Offer/_components/OfferMenu/OfferMenu.vue';

export default {
  components: {
    UnifiedOffersTable,
    ContentWrapper,
    OfferMenu,
  },
  mixins: [offerStatus],
  computed: {
    ...mapGetters('brand', ['currentBrandId']),
    ...mapGetters('user', ['hasAdminRights', 'isSystemAdmin', 'isEmployee']),
    ...mapState('user', {
      userBrand: 'brand',
      userRole: 'role',
    }),
    ...mapState('applications', ['statusColors']),
    isAuthorizedToManageOffers() {
      return this.isSystemAdmin || this.isEmployee;
    },
    brandId() {
      return this.currentBrandId(this.$route);
    },
  },
  methods: {
    ...mapActions('offer', ['editOffer', 'setOfferList']),
    ...mapActions('common', ['delete']),
    ...mapActions('routes', ['setRouteConfig']),
  },
  mounted() {
    this.setRouteConfig({
      route: this.$route,
      config: {
        queryFormatters: DEFAULT_QUERY_FORMATTERS,
        valueGetters: DEFAULT_VALUE_GETTERS,
      },
    });
  },
  setup() {
    return {
      PortalTarget,
    };
  },
};
</script>
